import {
  AppBar,
  Box,
  List,
  ListItem,
  ListItemText,
  Toolbar,
  useTheme,
} from '@mui/material'
import { useEffect } from 'react'
import { NavLink, Route, Routes, useLocation, Navigate } from 'react-router-dom'

import { KARMA_Route } from '@/types/karma/route'

import { SnackbarBridge } from '../api/'
import bgImage from '../assets/img/background.jpg'
import { CopyrightNotice } from '../components/'
import { LoginPage, UserRegister } from '../pages/'

const routes: KARMA_Route[] = [
  { component: UserRegister, hidden: true, path: 'register-page/:status' },
  { component: UserRegister, name: 'Registrieren', path: 'register-page' },
  { component: LoginPage, name: 'Anmeldung', path: 'login-page' },
]

export const Page = () => {
  const { pathname } = useLocation()
  const theme = useTheme()
  const color = theme.palette.white

  const isActive = (path: string) => pathname.includes(path)

  useEffect(() => {
    document.body.style.overflow = 'unset'
  }, [])

  return (
    <>
      <SnackbarBridge />
      <AppBar sx={{ backgroundColor: 'transparent' }}>
        <Toolbar>
          <List sx={{ display: 'flex', flexDirection: 'row' }}>
            {routes
              .filter(f => f.hidden !== true)
              .map(route => {
                const { name, path, redirect } = route
                const backgroundColor = isActive(path)
                  ? 'rgba(255, 255, 255, 0.1)'
                  : 'none'

                return redirect ? null : (
                  <NavLink key={path} to={path}>
                    <ListItem
                      sx={{
                        backgroundColor,
                        color,
                        textTransform: 'uppercase',
                      }}
                    >
                      <ListItemText disableTypography={true} primary={name} />
                    </ListItem>
                  </NavLink>
                )
              })}
          </List>
        </Toolbar>
      </AppBar>

      <Box
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'cover',
          display: 'flex!important',
          minHeight: '100vh',
        }}
      >
        <Routes>
          <Route index element={<Navigate to={'login-page'} replace />} />

          {routes.map(({ component: Comp, path }) => (
            <Route key={path} path={path} element={<Comp />} />
          ))}
        </Routes>

        <CopyrightNotice
          sx={{
            bottom: 0,
            color,
            position: 'absolute',
            textAlign: 'center',
            width: '100%',
          }}
        />
      </Box>
    </>
  )
}
